import React from 'react';

const DashboardWidgetPlaceholderCollection = () => (
  <div className="widget widget-grid-skeleton collections-item invisible">
    <div>
      <div className="collections-item-img-wrapper" />
      <div className="collections-item-body" />
    </div>
  </div>
);

export default DashboardWidgetPlaceholderCollection;
